import styled from 'styled-components';
// import { ReactComponent as Wave } from 'assets/img/images/back-wave.svg';
import Wave from 'assets/img/images/back-wave.svg';
import { Link } from 'react-router-dom';

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-image: url(${Wave});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #203662;
  width: 684px;
  height: 294px;
  padding: 0 15px;
  border-radius: 16px;
  color: #fff;
`;

export const SpeakerImg = styled.img`
  /* width: 100%; */
  height: 100%;
  user-select: none;
  pointer-events: none;
  margin-right: 20px;
`;

export const EventDetailContainer = styled.div`
  /* height: 100%; */
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 0;
  height: calc(100% - 40px);
  width: 65%;
`;

export const Context = styled.div`
  position: relative;
  height: 85%;
`;

export const UpcomingText = styled.span`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: -0.02em;
  color: #FFFFFF;
  margin-bottom: 8px;
  opacity: 0.8;
`;

export const EventTitleText = styled.p`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: -0.02em;
  margin-bottom: 15px;
  color: #FFFFFF;
`;

export const EventDescriptionText = styled.p`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: -0.02em;
  color: #FFFFFF;
  max-height: 73%;
  overflow: hidden;
  
  white-space: break-spaces;
  display: block;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 7;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
`;

export const ButtonArea = styled.div`
  display: flex;
  align-items: center;
`;

export const DetailBtn = styled(Link)`
  user-select: none;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0.005em;
  color: #fff;
  cursor: pointer;
`;
